module.exports = __webpack_public_path__ + "img/police.1e3cb9c9.jpeg";